import superUserRequest from 'utils/superUserRequest';

const fetchPlans = async () => {
  const response = await superUserRequest('GET', '/v1/plans/');
  return response;
};

const PLANS_QUERIES = {
  FETCH_PLANS: fetchPlans,
};

export default PLANS_QUERIES;
